import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "fixed w-screen h-screen z-20 bg-black bg-opacity-60" }
const _hoisted_2 = {
  key: 0,
  class: "w-1/2 bg-gray-100 mx-auto inset-x-0 mt-5 border-4 border-gray-100 pb-5 h-max"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "bg-opacity-80 bg-blue-200 mb-5 text-lg" }, "Data Contribution", -1)
const _hoisted_4 = {
  key: 0,
  class: "px-5 text-left text-sm"
}
const _hoisted_5 = { class: "grid grid-cols-4" }
const _hoisted_6 = { class: "object-center col-span-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "bg-opacity-80 bg-blue-100 text-base text-center mt-3" }, " Report Reuse ", -1)
const _hoisted_8 = {
  key: 0,
  class: "w-full h-full bg-green-100 text-xs text-green-800 mt-2 py-1 px-2"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" ✅ Report submitted successfully. ")
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs mt-3" }, [
  /*#__PURE__*/_createTextVNode(" Based on a publication identified by its "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.doi.org/",
    target: "_blank",
    class: "text-blue-500"
  }, "DOI"),
  /*#__PURE__*/_createTextVNode(" you can report any reuse of research artifacts or results presented in the paper. When you enter the DOI below details for this publication will be retrieved. ")
], -1)
const _hoisted_12 = {
  key: 1,
  class: "bg-blue-300 text-blue-900 p-3 mb-3"
}
const _hoisted_13 = {
  key: 2,
  class: "bg-yellow-300 text-yellow-900 p-3 mb-3"
}
const _hoisted_14 = { key: 3 }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "grid grid-cols-2 gap-4 mt-2" }
const _hoisted_17 = {
  key: 4,
  class: "grid grid-cols-2 gap-4"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_19 = {
  key: 1,
  class: "px-5 text-left text-sm"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, " Our review process is maintained through GitHub issues. To contribute data, we need a valid GitHub token from you in order to create issues for your contribution requests. We store the token in the local storage of your browser. It will never leave your machine other than to make requests to GitHub for data contributions for our project. ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, [
  /*#__PURE__*/_createTextVNode(" You can create such a personal access token at "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/settings/tokens",
    class: "text-blue-500",
    target: "_blank"
  }, "https://github.com/settings/tokens"),
  /*#__PURE__*/_createTextVNode(". Please set the following permissions: "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-mono" }, "public_repo")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, " As tokens can have an expiry date you may see this dialog when your token is not valid anymore. In this case, please update it with a new token. ", -1)
const _hoisted_23 = { class: "mt-2" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" We will use your token to create issues in our own repository ")
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" directly from your browser. ")
const _hoisted_27 = {
  key: 0,
  class: "mb-3 bg-yellow-300 text-yellow-900 p-3"
}
const _hoisted_28 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_29 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_grid_vue = _resolveComponent("ag-grid-vue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.tokenValid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("p", _hoisted_6, "👤 " + _toDisplayString(_ctx.githubUser.login), 1),
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.forgetToken())),
                    class: "min-h-4 bg-blue-500 hover:bg-blue-400 rounded-lg shadow-lg text-white p-1",
                    title: "Removes the stored GitHub access token from your browsers local storage."
                  }, " Forget token ")
                ]),
                _hoisted_7,
                (_ctx.submitSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("a", {
                        href: _ctx.lastIssueUrl,
                        target: "_blank",
                        class: "text-blue-500"
                      }, "View issue.", 8, _hoisted_10)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "DOI (e.g. 10.1145/3368089.3409767)",
                  class: "w-full mt-3 mb-3 p-2",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reuse.sourceDoi) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.reuse.sourceDoi]
                ]),
                (_ctx.loadingPublication)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Loading publication details... "))
                  : _createCommentVNode("", true),
                (_ctx.invalidDOI)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Invalid DOI used. "))
                  : _createCommentVNode("", true),
                (_ctx.sourceWork.dOI)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("p", null, [
                        _createElementVNode("a", {
                          href: `https://doi.org/${_ctx.sourceWork.dOI}`,
                          target: "_blank",
                          class: "text-blue-500"
                        }, _toDisplayString(_ctx.sourceWork.title.join("")), 9, _hoisted_15)
                      ]),
                      _createElementVNode("p", null, " by " + _toDisplayString(_ctx.sourceWork.author.map((a) => `${a.given} ${a.family}`).join(", ")), 1),
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addRow && _ctx.addRow(...args))),
                        class: "h-8 min-w-8 p-2 bg-blue-500 hover:bg-blue-400 rounded-lg shadow-lg text-white mt-1"
                      }, " Add row "),
                      _createVNode(_component_ag_grid_vue, {
                        class: "ag-theme-balham w-full h-64 mt-2 font-serif",
                        columnDefs: _ctx.columnDefs,
                        rowData: _ctx.reuse.reuse,
                        animateRows: true,
                        defaultColDef: _ctx.defaultColDef,
                        enableCellTextSelection: true,
                        onGridReady: _ctx.onGridReady,
                        onCellValueChanged: _ctx.onCellValueChanged,
                        tooltipShowDelay: 500
                      }, null, 8, ["columnDefs", "rowData", "defaultColDef", "onGridReady", "onCellValueChanged"]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("button", {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.startRequest())),
                          class: "min-h-8 w-full bg-blue-500 hover:bg-blue-400 rounded-lg shadow-lg text-white p-1"
                        }, " Start contribution request "),
                        _createElementVNode("button", {
                          class: "h-8 bg-blue-500 hover:bg-blue-400 rounded-lg shadow-lg text-white",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideDialog()))
                        }, " Cancel ")
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("button", {
                        class: "h-8 bg-blue-500 hover:bg-blue-400 rounded-lg shadow-lg text-white",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hideDialog()))
                      }, " Cancel ")
                    ]))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _hoisted_20,
                _hoisted_21,
                _hoisted_22,
                _createElementVNode("p", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("a", {
                    class: "text-blue-500",
                    href: `https://github.com/${_ctx.owner}/${_ctx.repo}`,
                    target: "_blank"
                  }, _toDisplayString(_ctx.owner) + "/" + _toDisplayString(_ctx.repo), 9, _hoisted_25),
                  _hoisted_26
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "",
                  id: "",
                  class: "w-full mt-3 mb-3 p-2",
                  placeholder: "GitHub token goes here",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.token) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.token]
                ]),
                (_ctx.invalidToken)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_27, " The token is not valid (currently). "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["min-h-8 rounded-lg shadow-lg text-white", 
              _ctx.token && _ctx.token != ''
                ? 'bg-blue-500 hover:bg-blue-400'
                : 'bg-gray-500 hover:bg-gray-500'
            ]),
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.storeToken())),
                    disabled: !_ctx.token || _ctx.token == ''
                  }, " Check Token ", 10, _hoisted_29),
                  _createElementVNode("button", {
                    class: "h-8 bg-blue-500 hover:bg-blue-400 rounded-lg shadow-lg text-white",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.hideDialog()))
                  }, " Cancel ")
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}